import Button from 'baby-ui/foundation/Button'
import { Wave } from 'components/curves'
import { mobileAppDownloadPath } from 'lib/urls'
import { track, TrackImpression, useTracking } from 'lib/analytics'
import css from './MobileAddItems.styles.scss'
import AddItemsLink from './components/AddItemsLink/AddItemsLink'
import { useLinkData } from './MobileAddItems.utils'

interface MobileAddItemsProps {
  isRouterMounted: boolean
}

const MobileAddItems = ({ isRouterMounted }: MobileAddItemsProps) => {
  const tracker = useTracking()
  const sharedTrackingProperties = {
    event: track.addItemsScreenClicked,
    eventLocation: track.EventLocation.ADD_ITEMS,
  }
  const links = useLinkData({ sharedTrackingProperties })

  const handleGetAppClick = () => {
    tracker.trackEvent({
      ...sharedTrackingProperties,
      eventCta: 'App Download',
    })
    setTimeout(() => {
      window.location.href = mobileAppDownloadPath()
    }, 150)
  }

  return (
    <TrackImpression
      eventProperties={{
        event: track.addItemsScreenViewed,
        eventLocation: sharedTrackingProperties.eventLocation,
      }}
      shouldFireEvent={isRouterMounted}
    >
      <div className={css.mobileAddItems__cta}>
        <div className={css.mobileAddItems__ctaImageContainer}>
          <img
            alt="App Example"
            className={css.mobileAddItems__ctaImage}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1679333676/Hero_phone_mferv0.png"
          />
        </div>
        <div className={css.mobileAddItems__ctaContent}>
          <h1 className={css.mobileAddItems__headerText}>
            Add from any store using our 5-star app
          </h1>
          <ul className={css.mobileAddItems__bulletWrapper}>
            <li className={css.mobileAddItems__bulletRainbow}>
              ADD FROM ANY WEBSITE
            </li>
            <li className={css.mobileAddItems__bulletTriangle}>ONE REGISTRY</li>
          </ul>
          <Button
            className={css.mobileAddItems__ctaButton}
            onClick={handleGetAppClick}
          >
            Get the app
          </Button>
        </div>
        <Wave color="#fff" position="bottom" />
      </div>
      <div className={css.mobileAddItems__linksContainer}>
        <h2 className={css.mobileAddItems__linksHeader}>
          Here are some ways to build your registry:
        </h2>
        {links.map((link) => (
          <AddItemsLink link={link} />
        ))}
      </div>
    </TrackImpression>
  )
}

export default MobileAddItems
